import React from "react";
import { observer } from "mobx-react";

import { useStore } from "../../store";
import { GlobalErrorType } from "../../store/appStoreTypes";
import { setWebBridge } from "../../utils/webBridge";
import GlobalErrorPanelView from "./GlobalErrorPanelView";

const GlobalErrorPanel = () => {
  const {
    appStore: { appErrorState, onUpdateToken },
    feedStore: { feedErrorState, onUpdateFeedError },
    searchStore: { searchErrorState, onUpdateSearchError },
    detailStore: { detailErrorState, onUpdateDetailError },
  } = useStore();

  const isAppError = appErrorState !== GlobalErrorType.NONE;
  const isFeedError = feedErrorState !== GlobalErrorType.NONE;
  const isSearchError = searchErrorState !== GlobalErrorType.NONE;
  const isDetailError = detailErrorState !== GlobalErrorType.NONE;

  const isOpen = isAppError || isFeedError || isSearchError || isDetailError;
  if (!isOpen) return null;

  const isNetworkError =
    feedErrorState === GlobalErrorType.NET_WORK ||
    searchErrorState === GlobalErrorType.NET_WORK ||
    detailErrorState === GlobalErrorType.NET_WORK;

  const onClick = () => {
    if (isAppError) {
      return setWebBridge({ name: "onWebClose" });
    }

    if (isFeedError) onUpdateFeedError(GlobalErrorType.NONE);
    if (isSearchError) onUpdateSearchError(GlobalErrorType.NONE);
    if (isDetailError) onUpdateDetailError(GlobalErrorType.NONE);

    // network error 인 경우 token 갱신
    if (isNetworkError) onUpdateToken();
  };

  const locoKey = isNetworkError
    ? "feed_server_connection_failed_error_msg"
    : "feed_server_unknown_error_msg";

  return <GlobalErrorPanelView isOpen locoKey={locoKey} onClick={onClick} />;
};

export default observer(GlobalErrorPanel);
